export default __webpack_public_path__ + "static/media/WildWater_11.e857b723.png";